module.exports = "<div class=\"input-group-append\" *ngIf=\"isShow\">\n    <span class=\"input-group-text\"><i class=\"fa fa-times\"></i></span>\n</div>"